import { render, staticRenderFns } from "./IcoTax.vue?vue&type=template&id=1d154e82"
import script from "./IcoTax.vue?vue&type=script&lang=js"
export * from "./IcoTax.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports